<script>
  import options from './DirectMessageThread.options'
  export default options
</script>

<template>
  <article class="kb-direct-message-thread kb-stafet-step">
    <div class="kb-direct-message-thread__header">

      <div class="kb-direct-message-thread__header-flex">
        <div v-if="!(chats && chats.length === 0)" class="kb-direct-message-thread__header-profile">
            <figure v-if="chatIcon" class="kb-image-module kb-image-module--1-1 kb-direct-message-thread__header-profile-profile-img">
                <div class="kb-image-module__image-container">
                    <picture class="kb-image-module__image">
                        <img :src="chatIcon" alt="" role="presentation" />
                    </picture>
                </div>
            </figure>
            <div class="kb-direct-message-thread__header-profile-texts">
    
                <div class="kb-direct-message-thread__header-profile-post-author-data">
                    <p class="kb-direct-message-thread__header-profile-post-author-data-name">
                      {{ chatName }}
                    </p>

                </div>
            </div>

        </div>

        <div v-else>
          <div class="kb-direct-message-thread__header-profile-texts">
    
              <div class="kb-direct-message-thread__header-profile-post-author-data">
                  <p class="kb-direct-message-thread__header-profile-post-author-data-name">
                    {{ getLabel('createNewChatTitle')}}
                  </p>

                  <div class="kb-direct-message-thread__header-users">
                    <p v-if="showCreateNewChatUsersLabel" class="kb-direct-message-thread__header-users-label">{{ getLabel('createNewChatUsersLabel') }}:</p>
                    <ul class="kb-direct-message-thread__header-users-list">
                      <li class="kb-direct-message-thread__header-users-item" v-for="user, index in newChatUsers" :key="index">{{ user.memberName }}</li>
                    </ul>
                  </div>
              </div>
          </div>
        </div>

        <div class="kb-direct-message-thread__header-actions">
          <button class="kb-link" v-if="!(chats && chats.length === 0)" v-on:click="deleteThread" aria-haspopup="true">{{ getLabel('deleteLabel') }}</button>
          <button class="kb-link" v-if="chats && chats.length === 0" v-on:click="showSearchForUser" :aria-expanded="showUserSearch">{{ getLabel('addUserLabel') }}</button>
        </div>

      </div>

      <div v-if="showUserSearch" class="kb-optimizely-forms kb-direct-message-thread__header-search">
        <FormInputTextField
            v-model="userSearchModel"
            fieldName="userSearchModel"
            :label="getLabel('userSearchLabel')"
            v-on:keyup="searchForUser"
          />
      </div>
      <div class="kb-general-search" aria-live="polite">
          <ul class="kb-direct-message-navigation__result-ul kb-direct-message-navigation__result-ul--search-results" v-if="listOfUsers && listOfUsers.length > 0">
              <li v-for="(result, index) in listOfUsers" :key="index" class="kb-direct-message-navigation__result-li">
                <button class="kb-direct-message-navigation__result-li-button"
                  v-on:click="addUserToThread(result)"
                  :id="`message-${result.id}`" >
                      <figure class="kb-image-module kb-image-module--1-1 kb-direct-message-navigation__result-member-profile-img">
                        <div class="kb-image-module__image-container">
                          <picture class="kb-image-module__image">
                            <img :src="result.memberImgSrc" :alt="result.resultImgAlt" />
                          </picture>
                        </div>
                      </figure>
                      <p class="kb-direct-message-navigation__result-member-name">
                        <span class="kb-direct-message-navigation__result-member-name-group">
                          <span class="kb-direct-message-navigation__result-member-name-group-name">{{ result.memberName }}</span>
                        </span>
                      </p>
                    </button>
              </li>
          </ul>     
        </div>
    </div>

    <div class="kb-direct-message-thread__content">
      <div class="kb-direct-message-thread__content-comments" ref="chatContentComponent">
        <template v-for="comments, index in chats" :key="index">
          <time class="kb-direct-message-thread__content-comments-timestamp">{{ comments.timestamp }}</time>
          <ul v-if="comments.comments.length > 0" v-for="comment, commentIndex in comments.comments" :key="commentIndex" class="kb-direct-message-thread__content-comments-list">
            <li class="kb-direct-message-thread__content-comment" :class="getClassModifier(comment)">
              <div v-if="editCommentId !== comment.id" class="kb-direct-message-thread__content-comment-wrapper">
                <p class="kb-direct-message-thread__content-comment-author">
                  {{ comment.author }}
                  <span  v-if="!comment.edited" class="kb-direct-message-thread__content-comment-author--edited-date"> 
                     {{ comment.createdOn }}
                  </span> 
                  <span  v-if="comment.edited" class="kb-direct-message-thread__content-comment-author--edited-date"> 
                    {{ comment.createdOn }} ({{ getLabel('editedLabel') }}: {{ comment.edited }})
                  </span> 
                </p>
                <article class="kb-direct-message-thread__content-comment-body">
                  <div class="kb-direct-message-thread__content-comment-text" v-html="comment.text"></div>
                </article>

                <AttachmentsViewer :files="comment.attachments" />
                
                <div v-if="comment.userId === userData.userId" class="kb-direct-message-thread__content-comment-actions">
                  <button v-on:click="() => editComment(comment.id, comment.text)" class="kb-link">{{ getLabel('editLabel') }}</button>
                  <button v-if="index > 0 || commentIndex > 0" v-on:click="(e) => deleteComment(e, comment.id)" class="kb-link" aria-haspopup="true">{{ getLabel('deleteLabel') }}</button>
                </div>
              </div>
              <div class="kb-direct-message-thread__content-comment-editor" v-else>
                <div class="kb-direct-message-thread__actions-editor-chat">
                  <editor api-key="no-api-key" :init='{
                      plugins: "emoticons autoresize lists autolink",
                      toolbar: "emoticons bold italic underline bullist numlist",
                      toolbar_location: "bottom",
                      menubar: false,
                      statusbar: false,
                      license_key: "gpl"
                    }'
                    v-model="editCommentModel"
                  ></editor>
                  <AttachmentsEditor 
                    :files="editCommentFiles"
                    @update:filesToAdd="$event => editCommentFilesToAdd = $event"
                    @update:filesToRemove="$event => editCommentFilesToRemove = $event"
                  />
                </div>
                <div class="kb-direct-message-thread__actions-editor-buttons">
                  <button v-on:click="() => cancelEditComment()" class="kb-button kb-button--spot-border-color">{{ getLabel('cancelLabel') }}</button>
                  <button v-on:click="() => saveEditComment(comment.id)" class="kb-button kb-button--full-color-spot">{{ getLabel('saveLabel') }}</button>
                </div>
              </div>
            </li>
          </ul>
        </template>
      </div>

      <div v-if="showSpinner" class="kb-spinner-overlay">
        <div class="kb-spinner-overlay__spinner"></div>
      </div>
    </div>

    <div class="kb-direct-message-thread__actions">
        <div class="kb-direct-message-thread__actions-editor">
          <editor api-key="no-api-key" :init='{
            plugins: "emoticons autoresize lists autolink",
            toolbar: "emoticons bold italic underline bullist numlist",
            toolbar_location: "bottom",
            menubar: false,
            statusbar: false,
            license_key: "gpl"
          }'
          v-model="newCommentModel"
        ></editor>
        <div aria-live="assertive">
          <p class="kb-forms Form__Element__ValidationError" role="alert" v-if="displayInputError">{{ getLabel('newCommentErrorLabel') }}</p>
        </div>

        <AttachmentsEditor
          :files="[]"
          @update:filesToAdd="$event => filesToAdd = $event"
          ref="attachmentsComponent"
        />

      </div>

      <button 
          :aria-label="getLabel('newCommentAriaLabel')"
          v-on:click="submitNewComment" 
          class="kb-post-comment__new-comment-button" 
          :class="{'kb-direct-message-thread__actions__new-message-button--disabled': showSpinner}">
        <svg viewBox="0 0 25 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m18.251 1 5.434 6-5.434 6" stroke="#fff" stroke-linejoin="round"></path><path d="M17.62 7H0" stroke="#fff"></path></svg>
      </button>
    </div>

  </article>
</template>
